import { SelectOrganization } from "./organization/select-organization";

export function OrganizationNotFoundError() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md space-y-6">
        <SelectOrganization
          showLogout={false}
          hideCreateOption={true}
          alert={{
            title: "Account Not Found",
            description:
              "The account you are looking for does not exist or you do not have permission to view it.",
            variant: "destructive",
          }}
        />
      </div>
    </div>
  );
}
